import ClientsEditorBase from "./ClientsEditorBase.jsx";
import { HasTaskHistoryBaseMixin } from "../../widget/mixins/HasTaskHistoryBaseMixin.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";

export default class ClientsTaskHistoryTab extends HasTaskHistoryBaseMixin(
  ClientsEditorBase
) {
  static get $name() {
    return "ClientsTaskHistoryTab";
  }

  static get type() {
    return "clientstaskhistorytabv2";
  }

  get swivuDeepLinkSlug() {
    return "history";
  }

  static get configurable() {
    return {
      tab : {
        icon: "fa-regular fa-clock w-4 h-4"
      },
      items: {
        taskHistoryGrid: {
          stateId: PERSISTENCE_STATE_KEYS.clientHistoryGrid
        }
      }
    };
  }

  getClientSchedulerEvents(project, task) {
    const { id, name, color, taskStyle } = task;
    const clientSchEventsDates = project.eventStore.findByField("taskId", id);
    return clientSchEventsDates.map(
      ({ data: { startDate, endDate, duration, durationUnit } }) => ({
        task,
        name,
        color,
        taskStyle,
        endDate,
        startDate,
        status: task.statusValue,
        duration: `${duration || ""} ${durationUnit || ""}`,
      })
    );
  }

  getClientSchedulerEventsHistory(project, tasks) {
    return tasks.reduce(
      (history, task) =>
        history.concat(this.getClientSchedulerEvents(project, task)),
      []
    );
  }

  loadRecord(record, context, otherParams) {
    super.loadRecord(record, context, otherParams);

    const { taskHistoryGrid } = this.widgetMap;
    if (record.tasks) {
      taskHistoryGrid.data = this.getClientSchedulerEventsHistory(
        context.project,
        record.tasks
      );
    } else {
      taskHistoryGrid.data = [];
    }
  }
}

ClientsTaskHistoryTab.initClass();
